<template>
  <div class="b-product-modal">
    <b-modal
      id="product-modal"
      size="lg"
      :lazy="true"
      :hide-footer="true"
      ref="productModalRef"
    >
      <ProductModalContent
        v-show="currentModalProduct"
        :product="currentModalProduct"
        :group="currentModalProductGroupName"
      />
    </b-modal>
  </div>
</template>

<script>
import ProductModalContent from "@/components/capsule/ProductModalContent";
import { bus } from "@/main";

export default {
  components: {
    ProductModalContent
  },

  mounted() {
    bus.$on("openModal", (product, groupName, refToFocusOnClose) => {
      this.showProductModal(product, groupName, refToFocusOnClose);
    });
  },

  data() {
    return {
      currentModalProduct: null,
      currentModalProductGroupName: null
    };
  },

  methods: {
    showProductModal(product, groupName, refToFocusOnClose) {
      this.currentModalProduct = product;
      this.currentModalProductGroupName = groupName;

      if (this.$refs.productModalRef) {
        this.$root.$emit('bv::show::modal', 'product-modal', `#${refToFocusOnClose}`)
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.modal-lg {
  max-width: 100% !important;

  @include for-tablet-portrait-up {
    max-width: 80% !important;
  }
}

.modal-header {
  border-bottom: 0;
  padding-bottom: 0;
}

.modal-content {
  border-radius: 4px;
}

.card-header {
  letter-spacing: 1px;
  color: $primary-blue;
  font-weight: 100;
  font-size: 12px;
  transition: all 0.2s ease-in;

  &:hover {
    font-weight: 600;
    color: white;
    background-color: $primary-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/ProductModal.vue